import Vue from 'vue';

export class P{
    constructor (data, { context, rootState }){
        this.id = data.id || '';
        this.product = data.product || '';
        this.price = data.price || '';
        this.context = context;
        this.rootState = rootState;
        this.isDefault = data.isDefault || false
    }

    apply(price){
        const priceData  = price.data
        this.product = priceData.product;
        this.price = priceData.price;
    }

    setContext (context){
        this.context = context;
    }

    setID(id){
        this.id = id;
    }

    updatePriceData(price){
        this.id = price.id;
        this.product = price.product;
        this.price = price.price;
    }

    get data (){
        return {
            id: this.id,
            product: this.product,
            price: String(this.price)
        };
    }
    async save (){
        if(this.isDefault){
            return await Vue.axios.post(`${this.rootState.config.priceServicePort}/price`, this.data, {
                headers: {
                    Store: this.context
                }
            }).then(({data}) => {
                this.updatePriceData(data);
                this.isDefault = false;
            });
        }
        let {data} = await Vue.axios.put(`${this.rootState.config.priceServicePort}/price/${this.id}`, this.data, {
            headers: {
                Store: this.context
            }
        });
    }
    delete (){
        return Vue.axios.delete(`${this.rootState.config.priceServicePort}/price/${this.id}`, {
            headers: {
                Store: this.context
            }
        });
    }
}
class Price{
    constructor (rootState, context){
        this.rootState = rootState;
        this.context = context;
    }

    async find (){
        let {data} = await Vue.axios.get(`${this.rootState.config.priceServicePort}/price`, {
            headers: {
                Store: this.context
            }
        });
        this._priceList = {};
        if(data) {
            data.filter(item => item).forEach(item => {
                this._priceList[item.product] = item;
            });
        }
        return this._priceList;
    }

    get priceList () {
        return this._priceList;
    }

    priceForProduct (productID){
        if(this.priceList[productID])
            return new P(this.priceList[productID], { context: this.context, rootState: this.rootState });
        else return new P({isDefault: true}, { context: this.context, rootState: this.rootState });
    }

}

export default Price;
